import { styled, keyframes } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

import { SCHEMA_LOADING_TEXT } from '../constants/DefaultValues';
import { THEME } from '../theming/theme';
import colors from '../theming/tokens/colors';

const background1 = ({ theme }) => {
  const bgColor = {
    [THEME.DENTOLO_THEME]: colors.DARK_GREEN,
    [THEME.PETOLO_THEME]: colors.DARK_ORANGE,
    [THEME.VITOLO_THEME]: colors.DUSTY_BLUE,
    [THEME.DA_DIREKT_THEME]: colors.DA_DIREKT_BRIGHT_ORANGE,
    [THEME.DA_KAUFLAND_THEME]: colors.DA_KAUFLAND_BLACK,
    [THEME.FRESSNAPF_THEME]: colors.COLOR_FOREST_GREEN,
  };

  return bgColor[theme?.name] || 'transparent';
};

const background2 = ({ theme }) => {
  const bgColor = {
    [THEME.DENTOLO_THEME]: colors.VITALIZED_GREEN,
    [THEME.PETOLO_THEME]: colors.VITALIZED_ORANGE,
    [THEME.VITOLO_THEME]: colors.DUSTY_BLUE,
    [THEME.DA_DIREKT_THEME]: colors.DA_DIREKT_BRIGHT_ORANGE,
    [THEME.DA_KAUFLAND_THEME]: colors.DA_KAUFLAND_BLACK,
    [THEME.FRESSNAPF_THEME]: colors.COLOR_FOREST_GREEN,
  };

  return bgColor[theme?.name] || 'transparent';
};

const bounce = (bg1, bg2) => keyframes`
  0%, 100% {
    transform: scale(0);
    background: ${bg1};
  }

  50% {
    transform: scale(1);
    background: ${bg2};
  }
`;

const StyledLoadingContainer = styled('div')`
  position: relative;
  margin: 0 auto;
  width: 4rem;
  height: 4rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const StyledLoadingCircle1 = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.6;
  animation: ${(props) => bounce(background1(props), background2(props))} 2s infinite ease-in-out;
`;

const StyledLoadingCircle2 = styled(StyledLoadingCircle1)`
  animation-delay: -1s;
`;

const getLoadingTextFont = ({ theme }) => {
  const loadingTextFont = {
    [THEME.DA_KAUFLAND_THEME]: 'p4',
    DEFAULT: 'body',
  };

  const fontToUse = loadingTextFont[theme?.name] || loadingTextFont.DEFAULT;
  return theme?.typography?.[`${fontToUse}`];
};

const StyledLoadingText = styled('p')`
  margin: 1rem auto 0;
  padding: 0;
  width: 100%;
  ${getLoadingTextFont};
  color: ${colors.GRAY};
`;

const LoadingAnimation = () => {
  return (
    <>
      <StyledLoadingContainer>
        <StyledLoadingCircle1 />
        <StyledLoadingCircle2 />
      </StyledLoadingContainer>

      <StyledLoadingText>
        <FormattedMessage id={SCHEMA_LOADING_TEXT} />
      </StyledLoadingText>
    </>
  );
};

export default LoadingAnimation;
